import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'
import { Menu } from '@mui/material'

export const MenuStyled = styled(Menu)`
  div {
    box-shadow: ${theme.effects.boxShadow['rule-01']};
  }
`
